
// 2026-09-30：角色折扣单价统一四舍五入到一位，显式会员价继续优先。
import {roleDiscountPrice} from '@/utils/roleDiscountPrice'
import { defineComponent, onMounted,computed,onUnmounted,reactive, ref } from 'vue'
import store from '@/store'
import prdRequest from '@/api/product'
import { message } from 'ant-design-vue';
import sysRequest from '@/api/sys'
// 2026-09-30：手机商品详情在当前页打开，返回可继续选择商品。
import {isMobileViewport} from '@/utils/mobilePresentation'
// 2026-10-06：详情原窗口返回恢复本列表历史条目的分页、筛选及位置。
import {createCatalogHistoryState} from '@/utils/catalogHistoryState'
// 2026-10-15：目录快照与同查询重试共用身份隔离缓存，交易仍实时校验。
import {createCatalogLoader,catalogIdentity} from '@/utils/catalogCache'
import router from '@/router'
import {SelectTypes} from '@/Interfaces/user/DataItem';
import CardData from "@/Interfaces/user/CardData"
import QrcodeVue from 'vue-qrcode'; 
import ImageViewer from '@/views/components/imageSearching.vue'
import { ProductType } from '@/Interfaces/enums/ProductType'
import { EnumOrderType } from '@/Interfaces/orders/EnumOrderType'
import ClothCard from '@/views/main/components/clothCard.vue'
export default defineComponent({
  components:{
    ClothCard,ImageViewer,QrcodeVue
  },
  setup() {
    const seasonStrings=ref<Array<string>>([]) 
    const pageSize=ref(20)   
    const bokes=ref<Array<CardData>>([])
    const total=ref(0)
    const cType=ref(-1)
    const current=ref(1)
    const uploadfiles=ref<HTMLInputElement|null>(null); 
    const coverShow=ref(false)
    const season=ref({a:false,b:false,c:false,d:false})    
    const isOpen=ref({
      favorate:false,
      master:false,
      season:false,
      order:false,
      category:false,
      imageSearching:false
    })
    const categoryData =ref<Array<SelectTypes>>([]);
    const clothCondition=reactive({
      orgId:store.getters.userInfo.orgId,
      productType:5,   //产品类型 0、版型  1、面料  2、辅料  3、饰品  4成衣  
      customerId:store.getters.userInfo.id,
      searchValue:"",
      org:-1,
      productFrom:null as number|null,
      prdIds:[] as Array<number>,
      seasonList:seasonStrings.value,
      categoryList:[],
      collection:null,
      season:null,
      category:null,
      // 2026-08-10：默认按系统商品类别序号展示，避免标题排序覆盖类别顺序。
      sort:'categoryIndex',
      self:null,
      favorites:"0",
      mounted:1,
      page:1,
      size:pageSize.value
    })
    const isPad=computed(()=>{
      return store.getters.isPad
    })
    // 2026-08-08：将页面“直营/第三方”选项转换为后端商品来源参数，修复成衣定制来源筛选无效。
    const setProductSource=(source:number)=>{
      clothCondition.org=source
      clothCondition.productFrom=source===1?2:source===2?1:null
      getAllProducts(1)
    }
    const resetCondition=()=>{
      clothCondition.searchValue=""
      clothCondition.org=-1
      clothCondition.productFrom=null
      clothCondition.seasonList=[]
      clothCondition.categoryList=[]
      clothCondition.collection=null
      clothCondition.season=null
      clothCondition.category=null
      clothCondition.sort='categoryIndex'
      clothCondition.favorites="0"
      clothCondition.page=1
      season.value={a:false,b:false,c:false,d:false}
      getAllProducts(1)
    }
    // 2026-10-15：先呈现同身份/同查询快照再刷新，失败不清空该查询，切页拒绝迟到回包。
    const catalogLoader=createCatalogLoader('cloths',bokes,total)
    const {loading:catalogLoading,error:catalogError,cached:catalogCached,retry:retryCatalog}=catalogLoader
    const getAllProducts=async(pageIndex)=>{
      pageIndex=Number.isInteger(pageIndex) && pageIndex>0?pageIndex:1
      // 2026-09-30：分类/筛选查询与翻页共用页码，防止请求第一页但分页控件仍停在旧页。
      current.value=pageIndex
      clothCondition.page=pageIndex  
      clothCondition.seasonList =seasonStrings.value
      clothCondition.size=pageSize.value 
      // 2026-08-11：分店成衣定制列表保持类型5，确保收藏筛选不与版型类型0混用。
      if(store.getters.orgId!==1000)clothCondition.productType=ProductType.成衣定制
      return catalogLoader.run(clothCondition,snapshot=>store.getters.orgId===1000?prdRequest.getPlatformBokeCloths(snapshot):prdRequest.getBranchBokeCloths(snapshot),res=>{
      if(res.data.list){
        total.value=res.data.total
        let list:Array<CardData>=[]
        let level //=store.getters.levels[store.getters.levels.length-1]
        if(store.getters.levels && store.getters.levels.length>0){
          if(store.getters.userInfo.id && store.getters.userInfo.executeLevel>0 && store.getters.userInfo.levelExpired>new Date().getTime()){
            level=store.getters.levels.find(itm=>itm.id=== store.getters.userInfo.executeLevel)
          }
          if(!level){
            level=store.getters.levels[store.getters.levels.length-1]
          }
        } 
        res.data.list.forEach(itm=>{
          list.push({
            code:itm.code,orgName:itm.orgName, 
            url:itm.mainImageUrl,
            productType:ProductType.成衣定制,
            favorite:itm.favorite,
            orgId:itm.orgId,prdOriOrgId:itm.prdOriOrgId,
            sizeGroup:itm.sizeGroup,
            description:itm.clothTitle?itm.clothTitle:itm.title,
            price2:itm.retailPrice,
            price1:(itm.memberPrice?itm.memberPrice:roleDiscountPrice(itm.retailPrice,level.bokeClothDiscount)),
            id:itm.id
          })      
        })
        bokes.value=list
        console.log(list)
      } 
      })
    }
    const categoryChanged=(val)=>{
      getAllProducts(1)
    }
    const previliges=computed(()=>{
      return store.getters.previliges
    })
    const vipVisibleFunctions=computed(()=>store.getters.vipVisibleFunctions || {})
    // 2026-08-31：收藏筛选与AI图片搜索按分店角色上限显示，客户VIP不足时仍保留升级可见性。
    const clientFunctionVisible=(functionName:string)=>Boolean(previliges.value[functionName] || vipVisibleFunctions.value[functionName])
    const catalogHistory=createCatalogHistoryState({current,pageSize,total,bokes,clothCondition,season,seasonStrings},
      ()=>String(store.getters.orgId)+':'+String(store.getters.userInfo.id || 0),catalogIdentity)
    const cardClick=(item)=>{
      if(item.productType==ProductType.版型 || item.productType==ProductType.成衣定制){        
        if(!previliges.value['商品明细弹窗查看'] || isPad.value || isMobileViewport()){
          catalogHistory.remember()
          router.push({  
            path: '/main/clothdetail', 
            query: {id:item.id}
          });
        }else{
          const url = `${window.location.origin}/main/clothdetail?id=${item.id}`;
          window.open(url, '_blank'); 
        }
      }else{
        catalogHistory.remember()
        router.push({  
          path: '/main/retailCloth',  
          query: {id:item.id}
        });
      }
      
    }
    const sort=(key)=>{
      clothCondition.sort=key
      getAllProducts(1)
    }
    const loadCategoryData = () =>{      
      
      // if(store.getters.categoryData && store.getters.categoryData.length>0){
      //   categoryData.value=[]
      //   store.getters.categoryData.forEach(item => {
      //     categoryData.value.push({label:item.name,value:item.id})
      //   })        
      // }else{
        store.dispatch('user/getCategoryData').then((res) => {
          categoryData.value=[]
          res.forEach(item => {
          categoryData.value.push({label:item.name,value:item.id})
        })
        }).catch((err) => {
          console.warn(err.message)
        })
      // }
    }
    const setSeasonId = () =>{
      const trueKeys = Object.keys(season.value).filter(key => season.value[key] === true); 
      const mapping = {a: 1,b: 2,c: 3,d: 4};
      const numArray = trueKeys.map(str => mapping[str]); 
      seasonStrings.value = trueKeys.map(str => mapping[str]); 
      clothCondition.seasonList=seasonStrings.value
      getAllProducts(1)          
    }
    const expend=(option)=>{
      cType.value=option
      setTimeout(()=>{
        if(cType.value==0){
          isOpen.value.season=false
          isOpen.value.order=false
          isOpen.value.master=false
          isOpen.value.category=false
          isOpen.value.imageSearching=false
          isOpen.value.favorate=!isOpen.value.favorate        
        }else if(cType.value==1){
          isOpen.value.favorate=false
          isOpen.value.order=false
          isOpen.value.master=false
          isOpen.value.category=false
          isOpen.value.imageSearching=false
          isOpen.value.season=!isOpen.value.season
        }else if(cType.value==3){
          isOpen.value.master=false
          isOpen.value.favorate=false
          isOpen.value.season=false
          isOpen.value.category=false
          isOpen.value.imageSearching=false
          isOpen.value.order=!isOpen.value.order
        }else if(cType.value==2){
          isOpen.value.season=false
          isOpen.value.order=false
          isOpen.value.favorate=false
          isOpen.value.category=false
          isOpen.value.imageSearching=false
          isOpen.value.master=!isOpen.value.master
        }else if(cType.value==4){
          isOpen.value.season=false
          isOpen.value.master=false
          isOpen.value.order=false
          isOpen.value.favorate=false
          isOpen.value.imageSearching=false
          isOpen.value.category=!isOpen.value.category
        }else if(cType.value==5){
          isOpen.value.season=false
          isOpen.value.master=false
          isOpen.value.order=false
          isOpen.value.favorate=false
          isOpen.value.category=false
          isOpen.value.imageSearching=!isOpen.value.imageSearching
        }
        
        if(!isOpen.value.favorate && !isOpen.value.master && !isOpen.value.order && !isOpen.value.season && !isOpen.value.category && !isOpen.value.imageSearching){
          cType.value=-1
          coverShow.value=false
        }else{
          coverShow.value=true
        }
      },50)
    }

    const closeAll=()=>{
      isOpen.value.season=false
      isOpen.value.master=false
      isOpen.value.order=false
      isOpen.value.favorate=false 
      isOpen.value.category=false 
      isOpen.value.imageSearching=false 
      setTimeout(() => {
        cType.value=-1
      }, 50);
    }
    const isQuerying=ref(false)
    const uploadImage=()=>{
      if(store.getters.userInfo.id){
        uploadfiles.value?.click()  
      }else{
        message.warn("您当前未登录，请先登录后再查询图片。")
      }
      
    }
    const imageFiles=ref<Array<any>>([])
    const deleteImage=(item)=>{      
      sysRequest.delSearchingHistories(item.id).then(res=>{
        imageFiles.value=imageFiles.value.filter(itm=>itm.id!=item.id)
        message.success("删除成功")
      })
    }
    const resetConditionOnly=()=>{
      clothCondition.searchValue=""
      clothCondition.org=-1
      clothCondition.productFrom=null
      clothCondition.seasonList=[]
      clothCondition.categoryList=[]
      clothCondition.collection=null
      clothCondition.season=null
      clothCondition.category=null
      clothCondition.sort='categoryIndex'
      clothCondition.favorites="0"
      clothCondition.page=1
      season.value={a:false,b:false,c:false,d:false}
    }
    const search=(id)=>{
      // 2026-10-15：图片搜索开始后不允许旧普通目录请求覆盖匹配结果。
      catalogLoader.invalidate()
      isQuerying.value=true
      sysRequest.searchImagesByPicById(id).then(res=>{
        const ids:Array<number>= []
        res.data.forEach(itm=>{
          const item=ids.find(id=>id==itm.entity.productId)
          if(!item){
            ids.push(itm.entity.productId)
          }          
        })
        resetConditionOnly()
        clothCondition.prdIds=ids
        clothCondition.productType=ProductType.成衣定制
        sysRequest.getProductsWithIds(clothCondition).then(prds=>{
          if(prds.data.list){
            total.value=prds.data.total
            let list:Array<CardData>=[]
              prds.data.list.forEach(itm=>{
              list.push({code:itm.code,orgName:itm.orgName, url:itm.mainImageUrl,productType:itm.productType,
                favorite:itm.favorite,orgId:store.getters.orgId,prdOriOrgId:itm.prdOriOrgId,
              description:itm.title,price1:itm.pltPrice,price2:itm.costPrice,id:itm.id})
            })
            bokes.value=list
            isQuerying.value=false
            isOpen.value.imageSearching=false
          }
        })
      }).catch(err=>{
        isQuerying.value=false
      })
    }
    const newImgChanged = (e) => {
      catalogLoader.invalidate()
      for(let file of e.target.files){        
        if(file.type=='image/jpeg' || file.type=='image/png'){
          isQuerying.value=true
          const formData = new FormData();  
          formData.append('file',file); 
          formData.append('customerId',store.getters.userInfo.id)
          formData.append('productType',"5")
          formData.append('imgType',file.type=='image/jpeg'?'jpeg':'png')
          sysRequest.searchImagesByPic(formData).then(res=>{
            imageFiles.value.push({id:res.data.id,originalUrl:ossHost.value+'/'+res.data.imageUrl})  
            const ids=res.data.results.map(itm=>itm.entity.productId)
            resetConditionOnly()
            clothCondition.prdIds=ids
            clothCondition.productType=ProductType.成衣定制
            sysRequest.getProductsWithIds(clothCondition).then(prds=>{
              if(prds.data.list){
                total.value=prds.data.total
                let list:Array<CardData>=[]
                  prds.data.list.forEach(itm=>{
                  list.push({code:itm.code,orgName:itm.orgName, url:itm.mainImageUrl,productType:itm.productType,
                    favorite:itm.favorite,orgId:store.getters.orgId,prdOriOrgId:itm.prdOriOrgId,
                  description:itm.title,price1:itm.pltPrice,price2:itm.costPrice,id:itm.id})
                })
                bokes.value=list
                isQuerying.value=false
                isOpen.value.imageSearching=false
              }
            })
          }).catch(()=>{
            isQuerying.value=false
          })
        }
      }
    }
    let loaded=false
    const qrcodeurl=ref('')
    let intervalId
    onUnmounted(()=>{
      if(intervalId){
        window.clearInterval(intervalId)
      }
    })
    const ossHost=computed(()=>{
      return store.getters.settings.imgurl.value
    })
    onMounted(async()=>{
      if(isPad.value){
        pageSize.value=16
      }
      const restored=catalogHistory.restore()
      if(store.getters.userInfo.id){
        // 2026-08-13：成衣定制扫码搜图传真实类型 5，避免本地后备结果被定制列表全部过滤。
        qrcodeurl.value= `${window.location.protocol}//${window.location.host}/imageSearching?customerId=${store.getters.userInfo.id}&productType=5&orgId=${store.getters.orgId}`
        sysRequest.getSearchingHistories(store.getters.userInfo.id).then(res=>{
          res.data.forEach(itm=>{
            if(itm.productType==5 || itm.productType==0){
              imageFiles.value.push({id:itm.id,originalUrl:ossHost.value+"/"+itm.url})    
            }  
          })
        })
        loaded=true
      }
      intervalId= window.setInterval(()=>{
        if(!store.getters.userInfo.id) return
        if(!loaded){
          // 2026-08-13：延迟登录后生成二维码时同样传真实成衣定制类型。
          qrcodeurl.value= `${window.location.protocol}//${window.location.host}/imageSearching?customerId=${store.getters.userInfo.id}&productType=5&orgId=${store.getters.orgId}`
          sysRequest.getSearchingHistories(store.getters.userInfo.id).then(res=>{
            res.data.forEach(itm=>{
              if(itm.productType==5 || itm.productType==0){
              imageFiles.value.push({id:itm.id,originalUrl:ossHost.value+"/"+itm.url})    
            }  
            })              
          })
          loaded=true
        }
        sysRequest.getSearchingResult(store.getters.userInfo.id).then(res=>{
          if(res.data){
              catalogLoader.invalidate()
            imageFiles.value.push({id:res.data.id,originalUrl:ossHost.value+'/'+res.data.imageUrl})  
            const ids=res.data.actions.map(itm=>itm.entity.productId)
            resetConditionOnly()
            clothCondition.prdIds=ids
            clothCondition.productType=ProductType.成衣定制
            sysRequest.getProductsWithIds(clothCondition).then(prds=>{
              if(prds.data.list){
                total.value=prds.data.total
                let list:Array<CardData>=[]
                  prds.data.list.forEach(itm=>{
                  list.push({code:itm.code,orgName:itm.orgName, url:itm.mainImageUrl,productType:itm.productType,
                    favorite:itm.favorite,orgId:store.getters.orgId,prdOriOrgId:itm.prdOriOrgId,
                  description:itm.title,price1:itm.pltPrice,price2:itm.costPrice,id:itm.id})
                })
                bokes.value=list
                isQuerying.value=false
                isOpen.value.imageSearching=false
              }
            })
          }
        })
      },2000)
      // 2026-10-06：普通查询重取原页；图片搜索保留匹配顺序及当前结果，避免返回被替换成普通列表。
      if(!restored || !clothCondition.prdIds.length){
        await getAllProducts(current.value)
      }
      await catalogHistory.restoreScroll()
      loadCategoryData()
    })
    return {
      catalogLoading,catalogError,catalogCached,retryCatalog,
      getAllProducts,bokes,clothCondition,total,current,uploadImage,cardClick,isOpen,cType,expend,setProductSource,pageSize,coverShow,closeAll,season,categoryChanged,
      setSeasonId,categoryData,uploadfiles,sort,resetCondition,isPad,imageFiles,deleteImage,qrcodeurl,newImgChanged,isQuerying,search,clientFunctionVisible
    }
  }
})
